export const LOG_LEVELS = {
  NONE: 'none',
  DEBUG: 'debug',
  INFO: 'info',
  WARN: 'warn',
  ERROR: 'error',
} as const;
